import React, { Component } from "react";
import { Grid, Container } from "semantic-ui-react";
import ProfileSummary from "../components/ProfileSummary";
import PortfolioNav from "../components/PortfolioNav";

export default class Home extends Component {
  render() {
    return (
      <Container>
        <Grid divided="vertically">
          <Grid.Row columns={2}>
            <Grid.Column mobile={16} tablet={6} computer={6}>
              <ProfileSummary />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={10} computer={10}>
              <PortfolioNav />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Home.js